export const states = {
	AccessDenied: 'accessDenied',
	ConnectorList: 'connectors',
	ConnectorEdit: 'connectors-edit',
	ConnectorCreate: 'connectors-new',
	ConnectorDuplicate: 'connectors-duplicate',
	ChartList: 'charts',
	ChartSelect: 'charts-select',
	ChartEdit: 'charts-edit',
	ChartVisualization: 'charts-view',
	DashboardCreate: 'new-dashboards',
	DashboardList: 'dashboards',
	DashboardEdit: 'dashboards-edit',
	DashboardCarousel: 'dashboards-carousel',
	DashboardVisualization: 'dashboards-view',
	DatablockList: 'datablocks',
	DatablockEdit: 'datablocks-edit',
	DatablockCreate: 'datablocks-new',
	DatablockDuplicate: 'datablocks-duplicate',
	DatablockFromDatablock: 'datablocks-fromDatablock',
	DatablockFromEntity: 'datablocks-fromEntite',
	DepotList: 'depots',
	DepotAngularJsEditPage: 'depots-edit',
	DepotAngularJSCreatePage: 'depots-new',
	DepotCreateModal: 'depots-new-v2-with-modal',
	DepotDuplicate: 'depots-duplicate',
	DepotV1ListCreateEntity: 'deprec-depot-list',
	DepotFromConnector: 'depots-fromConnector',
	EntityCreate: 'entites-new',
	EntityEdit: 'entites-edit',
	EntityDuplicate: 'entites-duplicate',
	EntityList: 'entites',
	ExportDatablockFromList: 'from-datablock-list',
	ExportTemplateList: 'export-template-list',
	ExportTemplateEdit: 'export-template-edit',
	ExpositionsList: 'expositions',
	ExpositionCreate: 'exposition-new',
	ExpositionView: 'exposition-view',
	ExpositionEditColumns: 'exposition-edit-columns',
	ExpositionEditApi: 'exposition-edit-api',
	ExpositionHistory: 'exposition-history',
	ExpositionDataSimulator: 'exposition-data-simulator',
	ExpositionFromDatablockList: 'exposition-from-datablock-list',
	ExpositionFromDatablockView: 'exposition-from-datablock-view',
	GenericsHome: 'module-generics',
	GridList: 'grids',
	GridSelect: 'grids-select',
	GridEdit: 'grids-edit',
	GridVisualization: 'grids-view',
	HandleHome: 'module-handle',
	HdHome: 'home',
	GdHome: 'gd-home',
	MapList: 'maps',
	MapCreate: 'maps-new',
	MapEdit: 'maps-edit',
	MapVisualization: 'maps-view',
	MediaList: 'medias',
	MediaSelect: 'medias-select',
	MediaEdit: 'medias-edit',
	MediaVisualization: 'medias-view',
	OrphanProjects: 'orphan-projects',
	Projects: 'projects',
	ProjectEdit: 'projects-edit',
	ProjectCreate: 'projects-new',
	RankingList: 'rankings',
	RankingEdit: 'rankings-edit',
	RankingCreate: 'rankings-new',
	SubscriptionList: 'project-subscriptions',
	SubscriptionCreate: 'project-subscription-new',
	SubscriptionCreateFromDatablockView:
		'subscription-create-from-datablock-view',
	SubscriptionView: 'project-subscription-view',
	SubscriptionSimulator: 'subscription-simulator',
	TimelineCreate: 'timelines-new',
	TimelineList: 'timelines',
	TimelineEdit: 'timelines-edit',
	TimelineVisualization: 'timelines-view',
};
